import { exists, SystemCodeAddress, SystemCodeArea } from '@/api'
import dayjs from 'dayjs'

export interface BatchStatisticsReserveConditionListItem {
  reserveDateFrom: string
  reserveDateTo: string
  reserveTitle: string
  branchCodeFrom: string
  branchCodeTo: string
  placeCodeFrom: string
  placeCodeTo: string
  areaCodeFrom: SystemCodeArea
  areaCodeTo: SystemCodeArea
  addressCodeForm: SystemCodeAddress
  addressCodeTo: SystemCodeAddress
  forwardingRequest: string
  isYearAge: boolean
  requestReserve: string
  xItem: string
  yItem1: string
  yCheck1: boolean[]
  yItem2: string
  yCheck2: boolean[]
  yItem3: string
  yCheck3: boolean[]
  yItem4: string
  yCheck4: boolean[]
  numberEnabled: boolean
  numberOfPeopleEnabled: boolean
  numberOfPeopleActualEnabled: boolean
  isOutputFull: boolean
  reserveMemo: string
  batchType: string
}

export function BatchStatisticsReserveConditionListItemFromJSON(
  json: any
): BatchStatisticsReserveConditionListItem {
  const resp = JSON.parse(json)

  return {
    reserveDateFrom: exists(resp, 'reserve_date_from')
      ? resp.reserve_date_from
      : dayjs()
          .add(-1, 'month')
          .format('YYYYMMDD'),
    reserveDateTo: exists(resp, 'reserve_date_to')
      ? resp.reserve_date_to
      : dayjs().format('YYYYMMDD'),
    reserveTitle: exists(resp, 'reserve_title') ? resp.reserve_title : '',
    branchCodeFrom: exists(resp, 'branch_code_from')
      ? resp.branch_code_from
      : '',
    branchCodeTo: exists(resp, 'branch_code_to') ? resp.branch_code_to : '',
    placeCodeFrom: exists(resp, 'place_code_from') ? resp.place_code_from : '',
    placeCodeTo: exists(resp, 'place_code_to') ? resp.place_code_to : '',
    areaCodeFrom:
      exists(resp, 'area_code_from') && resp.area_code_from !== ''
        ? resp.area_code_from
        : null,
    areaCodeTo:
      exists(resp, 'area_code_to') && resp.area_code_to !== ''
        ? resp.area_code_to
        : null,
    addressCodeForm:
      exists(resp, 'address_code_from') && resp.address_code_from !== ''
        ? resp.address_code_from
        : null,
    addressCodeTo:
      exists(resp, 'address_code_to') && resp.address_code_to !== ''
        ? resp.address_code_to
        : null,
    forwardingRequest: exists(resp, 'forwarding_request')
      ? resp.forwarding_request
      : '1',
    isYearAge: exists(resp, 'is_year_age') ? resp.isYearAge : false,
    requestReserve: exists(resp, 'request_reserve')
      ? resp.request_reserve
      : '1',
    xItem: resp.x_item,
    yItem1: resp.y_item1,
    yCheck1: exists(resp, 'y_check1') ? resp.y_check1 : [false, false],
    yItem2: exists(resp, 'y_item2') ? resp.y_item2 : '',
    yCheck2: exists(resp, 'y_check2') ? resp.y_check2 : [false, false],
    yItem3: exists(resp, 'y_item2') ? resp.y_item3 : '',
    yCheck3: exists(resp, 'y_check3') ? resp.y_check3 : [false, false],
    yItem4: exists(resp, 'y_item2') ? resp.y_item4 : '',
    yCheck4: exists(resp, 'y_check4') ? resp.y_check4 : [false, false],
    numberEnabled: exists(resp, 'number_enabled') ? resp.number_enabled : false,
    numberOfPeopleEnabled: exists(resp, 'number_of_people_enabled')
      ? resp.number_of_people_enabled
      : false,
    numberOfPeopleActualEnabled: exists(resp, 'number_of_people_actual_enabled')
      ? resp.number_of_people_actual_enabled
      : false,
    isOutputFull: exists(resp, 'is_output_full') ? resp.is_output_full : false,
    reserveMemo: resp.reserve_memo,
    batchType: resp.batch_type
  }
}
